export const Flex = {
  baseStyle: {
    display: 'flex',
    flexDirection: 'column'
  }
};
export const Spacer = {
  baseStyle: {
    flexGrow: 1
  }
};
//# sourceMappingURL=flex.js.map